import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { alpha, useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { useTranslate } from 'src/locales';
import { paths } from 'src/routes/paths';
import { usePathname } from 'src/routes/hooks';
import { RouterLink } from 'src/routes/components';

import Logo from 'src/components/logo';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------
export const _socials = [
  {
    value: 'facebook',
    name: 'FaceBook',
    icon: 'eva:facebook-fill',
    color: '#1877F2',
    path: 'https://www.facebook.com/profile.php?id=61575884409256',
  },
  {
    value: 'instagram',
    name: 'Instagram',
    icon: 'ant-design:instagram-filled',
    color: '#E02D69',
    path: 'https://www.instagram.com/tely.za?igsh=MXFjaGttNzA2aW9paw==',
  },
  {
    value: 'twitter',
    name: 'Twitter',
    icon: 'eva:twitter-fill',
    color: '#00AAEC',
    path: 'https://www.twitter.com/telyza',
  },
  {
    value: 'tiktok',
    name: 'TikTok',
    icon: 'fa-brands:tiktok',
    color: '#000000',
    path: 'https://www.tiktok.com/@telyza5?_t=ZM-8ydWChmk680&_r=1',
  },
];

// ----------------------------------------------------------------------

export default function Footer() {
  const { t } = useTranslate();
  const LINKS = [
    {
      headline: 'Telyza',
      children: [
        { name: t('aboutUs'), href: paths.about },
        { name: t('contactUs'), href: paths.contact },
        { name: t('faqs'), href: paths.faqs },
      ],
    },
    {
      headline: t('legal'),
      children: [
        { name: t('termsAndConditions'), href: '#' },
        { name: t('privacyPolicy'), href: '#' },
      ],
    },
    {
      headline: t('contact'),
      children: [
        { name: 'support@telyza.com', href: 'mailto:support@telyza.com' },
        { name: '+56 9 3146 4775 (Whatsapp)', href: 'https://wa.me/+56931464775' },
      ],
    },
  ];
  const pathname = usePathname();

  const theme = useTheme();

  const mainFooter = (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: theme.palette.primary.dark,
        color: '#ffffff',
      }}
    >
      <Divider />

      <Container
        sx={{
          pt: 10,
          pb: 5,
          textAlign: { xs: 'center', md: 'unset' },
        }}
      >
        <Logo sx={{ mb: 3 }} />

        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
        >
          <Grid xs={8} md={3}>
            <Typography
              variant="body2"
              sx={{
                maxWidth: 270,
                mx: { xs: 'auto', md: 'unset' },
              }}
            >
              {t('startingPoint')}
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mt: 3,
                mb: { xs: 5, md: 0 },
              }}
            >
              {_socials.map((social) => (
                <IconButton
                  key={social.name}
                  sx={{
                    '&:hover': {
                      bgcolor: alpha(social.color, 0.08),
                    },
                  }}
                  component="a"
                  href={social.path}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Iconify color={social.color} icon={social.icon} />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid xs={12} md={6}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }}>
              {LINKS.map((list) => (
                <Stack
                  key={list.headline}
                  spacing={2}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                  sx={{ width: 1 }}
                >
                  <Typography component="div" variant="overline">
                    {list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <Link
                      key={link.name}
                      component={RouterLink}
                      href={link.href}
                      color="inherit"
                      variant="body2"
                    >
                      {link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ mt: 10 }}>
          © 2025. All rights reserved
        </Typography>
      </Container>
    </Box>
  );

  return mainFooter;
}
